import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=0bfc31ab&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=0bfc31ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfc31ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bfc31ab')) {
      api.createRecord('0bfc31ab', component.options)
    } else {
      api.reload('0bfc31ab', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=0bfc31ab&scoped=true&", function () {
      api.rerender('0bfc31ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2haB0fdQBaF5U/JS/comp/DocBox.vue"
export default component.exports